import { FC, ReactNode } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import Home from '../views/Home'
import { Layout } from '../components/Layout'
import MerchDonations from '../views/MerchDonations'
import Events from '../views/Events'
import Contact from '../views/Contact'
import Cart from '../views/Cart'
import { isMarketplaceEnabled } from './featureFlags'

const MarketplaceGuard: FC<{ children: ReactNode }> = ({ children }) => {
  if (!isMarketplaceEnabled()) return <Navigate to='/' replace />
  return <>{children}</>
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <div>Oops, can not find this page</div>,
    children: [
      { index: true, element: <Home /> },
      { path: 'merch', element: <MarketplaceGuard><MerchDonations /></MarketplaceGuard> },
      { path: 'events', element: <Events /> },
      { path: 'contact', element: <Contact /> },
      { path: 'cart', element: <MarketplaceGuard><Cart /></MarketplaceGuard> },
      { path: '*', element: <Home /> },
    ],
  },
])
